import { Center, Flex, Heading, VStack } from "@chakra-ui/react";
import { PasswordInput } from "../../ui/input/password-input";
import { LoginFrame } from "../login/component/login-frame";
import { useReissue } from "./hooks/use-reissue";

export const Reissue = () => {
  const {
    verified,
    Footer,
    request,
    setRequest,
    validation,
  } = useReissue();

  /* トークンの確認が取れるまでは入力させない */
  if (!verified) {
    return <Center h="100vh" />;
  }

  return (
    <Center h="100vh">
      <LoginFrame>
        <Heading
          as="h1"
          fontSize="70px"
          fontWeight="normal"
          my="1.5rem"
          textShadow="0 2px 2px rgba(0, 0, 0, 0.25)"
        >
          MSPシステム
        </Heading>
        <VStack gap="1.5rem" w="100%">
          <PasswordInput
            placeholder="新しいパスワード"
            value={request.password}
            onChange={(e) => setRequest({ password: e.target.value })}
            validations={validation.password}
          />
          <PasswordInput
            placeholder="新しいパスワード（確認用）"
            value={request.password_confirmation}
            onChange={(e) => setRequest({ password_confirmation: e.target.value })}
            validations={validation.password_confirmation}
          />
        </VStack>
        <Flex w="100%" justifyContent="center" gap="1rem" pt="0.5rem">
          <Footer />
        </Flex>
      </LoginFrame>
    </Center>
  )
}
